import React from 'react';
import '../App.css';

function ShimmerBlock({ style, className = '' }) {
  return <div className={`shimmer-block ${className}`.trim()} style={style} aria-hidden />;
}

function ClientHomeShimmer() {
  return (
    <div className="client-home-shimmer" aria-busy="true" aria-label="Loading your portal">
      <div className="client-home-shimmer-head">
        <ShimmerBlock style={{ height: 18, width: '72%', maxWidth: 280, borderRadius: 8 }} />
        <ShimmerBlock style={{ height: 36, width: 140, borderRadius: 8, flexShrink: 0 }} />
      </div>
      <div className="client-home-shimmer-grid">
        {[0, 1].map((i) => (
          <div key={i} className="card client-home-shimmer-card">
            <div className="client-home-shimmer-card-accent" />
            <div className="card-body">
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                <ShimmerBlock style={{ height: 22, width: 88, borderRadius: 6 }} />
                <ShimmerBlock style={{ height: 18, width: 52, borderRadius: 6 }} />
              </div>
              <ShimmerBlock style={{ height: 22, width: '85%', borderRadius: 6, marginBottom: 16 }} />
              <ShimmerBlock style={{ height: 8, width: '100%', borderRadius: 4, marginBottom: 6 }} />
              <ShimmerBlock style={{ height: 8, width: '100%', borderRadius: 4, marginBottom: 16 }} />
              <div style={{ display: 'flex', gap: 8, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
                <ShimmerBlock style={{ flex: 1, height: 36, borderRadius: 6 }} />
                <ShimmerBlock style={{ flex: 1, height: 36, borderRadius: 6 }} />
                <ShimmerBlock style={{ flex: 1, height: 36, borderRadius: 6 }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export { ClientHomeShimmer };
